import { createGlobalStyle } from 'styled-components';

/* ---------------------------------------------------------
 AVOID PUTTING ANTHING HERE UNLESS ABOLUTELY NECESSARY

  All class styles should be associated with their component
  in a *componentname*Styled.js file and imported
 -----------------------------------------------------------*/

const GlobalStyle = createGlobalStyle`

	* {
		margin: 0;
		padding: 0;
	}
  
  body {
  padding: 0;
  margin: 0;
  font-family: purista-web, sans-serif;

  }

  @media screen and (max-width: 768px) {
   main{ margin-top: 80px;}
  }


`;

export default GlobalStyle;
